import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { catchError, firstValueFrom, Observable } from 'rxjs';

import { ValidationService } from '../../utils/valibot/validation.service';
import { FilterCriteria, ReportingOptions, ReportingOptionsSchema } from '../model/reporting.model';

@Injectable({
  providedIn: 'root',
})
export class ReportingClient {
  private static readonly urlPrefix = 'reporting';

  private readonly http = inject(HttpClient);
  private readonly logger = inject(NGXLogger);
  private readonly validationService = inject(ValidationService);

  getOptions(): Promise<ReportingOptions> {
    const url = `${ReportingClient.urlPrefix}`;
    this.logger.info(`#CDFTF0202 Fetching reporting filter options ${url}`);
    return firstValueFrom(
      this.http.get(url).pipe(
        this.validationService.pipeResponse(ReportingOptionsSchema),
        catchError((error: HttpErrorResponse) => {
          this.logger.error('#CDFTF0203 Unable to get reporting filter options', error);
          throw error;
        }),
      ),
    );
  }

  getReport(filterCriteria: FilterCriteria): Observable<HttpResponse<Blob>> {
    const url = `${ReportingClient.urlPrefix}/export`;
    this.logger.info(`#CDFTF0210 Fetching report ${url} with parameters: `, filterCriteria);
    return this.http.post(`${url}`, filterCriteria, { responseType: 'blob', observe: 'response' }).pipe(
      catchError((error: HttpErrorResponse) => {
        this.logger.error('#CDFTF0211 Retrieving the report failed', error);
        throw error;
      }),
    );
  }
}
